export default __webpack_public_path__ + "static/media/f_previewmodel.ed8f89f0.svg";